module.exports = __webpack_public_path__ + "02_short_gold.559763a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/02_short_gold.png
// module id = Y3iG
// module chunks = 0